"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._Error = {
    type: "structure",
    required: [],
    members: {
        Key: {
            shape: {
                type: "string",
                min: 1
            }
        },
        VersionId: {
            shape: {
                type: "string"
            }
        },
        Code: {
            shape: {
                type: "string"
            }
        },
        Message: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_Error.js.map